import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { onGetUtmsAsync } from '../Utm/Pension.slice'
import Spinner from '../../components/Spinners/Spinner'
import * as S from './DashboardUtmYear.styles'

const MONTH_LABELS = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
]

const DashboardUtmYear = () => {
  const dispatch = useDispatch()
  const { utms = [], loading, error } = useSelector((state) => state.adminPension)

  const now = useMemo(() => new Date(), [])
  const currentYear = now.getFullYear()
  const currentMonthIndex = now.getMonth()

  useEffect(() => {
    dispatch(onGetUtmsAsync())
  }, [dispatch])

  const yearUtmsByMonth = useMemo(() => {
    const map = new Map()

    utms
      .filter((utm) => Number(utm.targetYear) === currentYear)
      .forEach((utm) => {
        const monthIndex =
          typeof utm.targetMonthIndex === 'number'
            ? utm.targetMonthIndex
            : MONTH_LABELS.findIndex(
                (label) =>
                  label.toLowerCase() === String(utm.targetMonth).toLowerCase()
              )

        if (monthIndex < 0 || monthIndex > 11) return

        const existing = map.get(monthIndex)
        if (!existing || Number(utm.rawValue) >= Number(existing.rawValue)) {
          map.set(monthIndex, utm)
        }
      })

    return map
  }, [utms, currentYear])

  const monthCards = useMemo(
    () =>
      MONTH_LABELS.map((label, index) => ({
        monthIndex: index,
        label,
        utm: yearUtmsByMonth.get(index) || null,
        isCurrentMonth: index === currentMonthIndex,
      })),
    [yearUtmsByMonth, currentMonthIndex]
  )

  const hasYearData = yearUtmsByMonth.size > 0

  return (
    <S.Panel>
      {loading && <Spinner />}
      {!loading && error && (
        <S.ErrorText>No pudimos cargar los valores UTM.</S.ErrorText>
      )}

      {!loading && !error && (
        <S.MonthGrid>
          {monthCards.map((month) => (
            <S.MonthCard
              key={month.monthIndex}
              $current={month.isCurrentMonth && Boolean(month.utm)}
              $empty={!month.utm}
            >
              <S.MonthName $current={month.isCurrentMonth}>
                {month.label}
              </S.MonthName>
              {month.utm ? (
                <S.MonthValue>{month.utm.value}</S.MonthValue>
              ) : (
                <S.MonthEmpty>—</S.MonthEmpty>
              )}
              {month.isCurrentMonth && month.utm && (
                <S.MonthTag>Actual</S.MonthTag>
              )}
            </S.MonthCard>
          ))}
        </S.MonthGrid>
      )}

      {!loading && !error && !hasYearData && (
        <S.EmptyState>
          <S.EmptyHint>
            Aún no hay valores UTM del SII para {currentYear}.
          </S.EmptyHint>
        </S.EmptyState>
      )}
    </S.Panel>
  )
}

export default DashboardUtmYear
